import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) { nav("/accedi"); return; }
    (async () => {
      try {
        const r = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(r.data.user);
        window.history.replaceState(null, "", "/account");
        nav("/account");
      } catch (error) {
        console.error("Google session exchange failed:", error);
        nav("/accedi");
      }
    })();
  }, [nav, setUser]);

  return <div className="py-32 text-center text-slate-400">Accesso in corso...</div>;
}
